import type { GatsbyBrowser } from "gatsby";
import { WrapPageElement, WrapRootElement } from "./src/components/layout/wrap-element";
import { EVENT, EventAggregator, ServiceHelper } from "@preem/core";
import { globalHistory } from "@reach/router";
import TagManager from "./src/components/tracking/tag-manager";
import { captureUtmParams } from "./src/helpers/utm-helper";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element, props }) => {
  return <WrapPageElement props={props}>{element}</WrapPageElement>;
};

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  return <WrapRootElement>{element}</WrapRootElement>;
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = (props) => {
  EventAggregator.publish("onRouteUpdate", props);
};

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  captureUtmParams();

  const API_BASE_URL = process.env.GATSBY_API_BASE_URL;
  const API_SUBSCRIPTION_KEY = process.env.GATSBY_API_SUBSCRIPTION_KEY;

  if (API_BASE_URL) {
    ServiceHelper.setBaseConfig({ url: API_BASE_URL, subscriptionKey: API_SUBSCRIPTION_KEY });
  }

  globalHistory.listen((listener) => {
    EventAggregator.publish(EVENT.HISTORY_ACTION, listener.action);
  });

  EventAggregator.subscribe(EVENT.TRACK_EVENT, (event: unknown) => {
    TagManager.dataLayerPush(event);
  });
};
